import React, { useState, useEffect, useContext } from 'react';
import * as Yup from 'yup';
import {
    CrudMasterDetailView,
    GridView,
    Widget,
    FormSubmitButton,
    CompositeView,
    MasterDetailForm,
    FormatText,
    FormTextArea,
    CrudContext,
    useRouter,
    Row,
    Col,
    FormNumber,
    Button,
} from '@digital/ui';
import UploadFile from '@app/components/uploadFile';

import {
    CicloOrcamentario,
    getAllCicloOrcamentario,
    createCicloOrcamentario,
    updateCicloOrcamentario,
    CicloOrcamentarioJoinProjeto,
    getAllcicloOrcamentarioHasJoinProjeto,
    CicloOrcamentarioHasJoinProjeto,
    createPlanilhaTpa,
    exportaCicloOrcamentarioAno,
} from '../../api/cicloorcamentario';

import CicloOrcamentarioTableComponent from './CicloOrcamentarioTable';
import { hasPermission } from '@app/helpers/permissions';
import { exportaModelo } from '@app/api/exportaFile';

const validationSchema = Yup.object().shape({
    ano: Yup.string()
        .required('Ano deve ser informado')
        .max(5, 'O Ano deve ter no máximo 4 caracteres.')
        .nullable(),
    descricao: Yup.string().max(2000, 'Notas deve ter no máximo 2000 caracteres.'),
});

const CicloOrcamentarioComponent = () => {
    const { history } = useRouter();
    const { selectedItem } = useContext(CrudContext);
    const [ciclos, setCiclos] = useState(() => getAllCicloOrcamentario);
    const [projetos, setProjetos] = useState<CicloOrcamentarioHasJoinProjeto[]>();
    const [hasFile, setHasFile] = useState(true);

    useEffect(() => {
        const getCiclosData = async () => {
            const result = await getAllCicloOrcamentario();
            if (result) setCiclos(result);
        };
        getCiclosData();
    }, []);

    const listarCiclosOrcamentarios = () => {
        setCiclos(() => Promise.resolve(undefined));
        setCiclos(() => getAllCicloOrcamentario);
    };

    const onCreateCicloOrcamentario = (ciclo: CicloOrcamentario) => {
        return createCicloOrcamentario(ciclo).then(resp => {
            if (resp.valid) {
                listarCiclosOrcamentarios();
                //window.location.href = '/cicloOrcamentario';
                window.location.href = `/cicloOrcamentario/detail/${resp && resp.id}`;
            }
            return resp;
        });
    };

    const handleCreatePlanilhaTpa = (values: any, selectedItem: any) => {
        if (!selectedItem) {
            const ciclo: CicloOrcamentario = {
                descricao: values.descricao ? values.descricao : '',
                ano: values.ano,
            };
            onCreateCicloOrcamentario(ciclo);
        } else {
            createPlanilhaTpa(selectedItem.id, values.formData, values).then(result => {
                if (result.valid) {
                    setHasFile(true);
                    setHasFile(false);
                    setCiclos(() => Promise.resolve(undefined));
                    setCiclos(() => getAllCicloOrcamentario);
                    handleJoinProjeto('', selectedItem.id);
                }
            });
        }
    };

    const onUpdateCicloOrcamentario = (ciclo: CicloOrcamentario) => {
        return updateCicloOrcamentario(ciclo).then(resp => {
            if (resp.valid) listarCiclosOrcamentarios();
            return resp;
        });
    };


    const handleJoinProjeto = async (PId: string, CId: string) => {
        const join: CicloOrcamentarioJoinProjeto = {
            projetoId: PId,
            cicloOrcamentarioId: CId,
        };
        const result = await getAllcicloOrcamentarioHasJoinProjeto(join);
        if (result) {
            setProjetos(result);
        }
    };


    const exportarModelo = (modelo: string) => {
        if (modelo) {
            exportaModelo(modelo);
        }
    };

    return (
        <CrudMasterDetailView
            getAllItems={ciclos}
            createItem={hasPermission(['CICLO_ORCAMENTARIO_CADASTRAR']) ? onCreateCicloOrcamentario : undefined}
            updateItem={hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) ? onUpdateCicloOrcamentario : undefined}
            disableNotification
            icon="business-process"
            detailTitleExtractor={item => `${item.ano}`}
            filterPredicate={(item, value) =>
                (item.descricao && item.descricao.toLowerCase().includes(value.toLowerCase())) ||
                (item.ano !== undefined &&
                    item.ano
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()))
            }
            titleExtractor={item => `${item.ano}`}
            descriptionExtractor={item => ''}>
            <CompositeView>
                {hasPermission(['Dono', 'MODULO_CADASTRO_BASICO_VISUALIZAR_MENU']) && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            return (
                                <GridView noform>
                                    <MasterDetailForm
                                        validationSchema={validationSchema}
                                        onSubmit={values => {
                                            handleCreatePlanilhaTpa(values, selectedItem);
                                        }}>
                                        <Widget
                                            title="Dados do Ciclo Orçamentário"
                                            actions={[
                                                selectedItem && hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) && (
                                                    [
                                                        <Button
                                                            type="link"
                                                            icon="files-xls"
                                                            onClick={() => {
                                                                exportarModelo('modeloTap');
                                                            }}>
                                                            Modelo de importação Finplan
                                                        </Button>,
                                                        <Button
                                                            type="primary"
                                                            size={'small'}
                                                            icon="files-ms_excel"
                                                            onClick={() => {
                                                                if (selectedItem)
                                                                    exportaCicloOrcamentarioAno(selectedItem.id)
                                                            }}>
                                                            Exporta Relatório
                                                        </Button>
                                                    ]
                                                ),

                                                hasPermission(['CICLO_ORCAMENTARIO_CADASTRAR', 'CICLO_ORCAMENTARIO_EDITAR']) && (
                                                    <FormSubmitButton type="primary">
                                                        <FormatText id="ui.commons.save" uppercase />
                                                    </FormSubmitButton>
                                                ),
                                            ]}>
                                            <FormNumber label="Ano" name="ano" span={2} disabled={selectedItem && selectedItem.id} />
                                            <FormTextArea label="Notas" placeholder="" name="descricao" rows={3} />
                                            {selectedItem && hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) && (
                                                <UploadFile
                                                    hasFile={hasFile}
                                                    accept={'.xlsx'}
                                                    label="Incluir Taps"
                                                    id="importFilePlanilha"
                                                    selectedItem={selectedItem}
                                                />
                                            )}
                                        </Widget>
                                        {selectedItem && (
                                            <Widget
                                                title={"Projetos Associados"}>
                                                <CicloOrcamentarioTableComponent
                                                    titulo="Projetos Associados"
                                                    data={projetos || []}
                                                    handleJoinProjeto={handleJoinProjeto}
                                                    cicloOrcamentarioId={selectedItem && selectedItem.id}
                                                />
                                            </Widget>
                                        )}
                                    </MasterDetailForm>
                                </GridView>
                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView>
    );
};

export default CicloOrcamentarioComponent;
